import http from '.'

export const log = (data)=>{
    return http.post(`/log`, data)
}